<template>
  <div class="women_bible">
    <!-- header -->
    <WomenHeader
      :currentPage="currentPage"
      @update:page="currentPage = $event"
    />
    <main>
      <!--page_one-->
      <WomenHome />
      <!--page_two-->
      <WomenFunction />
      <!--page_three-->
      <WomenValues />
      <!--page_four-->
      <WomenFeatures />
      <!--page_five-->
      <WomenComment />
      <!--page_six-->
      <WomenDown />
      <!--page_faq-->
      <WomenFAQ />
    </main>
    <!--page_footer-->
    <WomenFooter
      :currentPage="currentPage"
      @update:page="currentPage = $event"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import WomenHeader from "@/components/WomenHeader.vue";
import WomenHome from "@/components/WomenHome.vue";
import WomenFunction from "@/components/WomenFunction.vue";
import WomenValues from "@/components/WomenValues.vue";
import WomenFeatures from "@/components/WomenFeatures.vue";
import WomenComment from "@/components/WomenComment.vue";
import WomenDown from "@/components/WomenDown.vue";
import WomenFAQ from "@/components/WomenFAQ.vue";
import WomenFooter from "@/components/WomenFooter.vue";
import { sendTA } from "@/assets/js/TA";

const currentPage = ref("home");
watch(currentPage, (newVal, oldVal) => {
  sendTA("XWEB_CLICK", {
    name: `bible_${newVal}_click`,
  });
  document.getElementById(newVal)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
});
</script>
<style lang="less" scoped>

.women_bible {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
}
</style>
